import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteSupplier } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useForceDeleteSupplier = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteSupplierMutate, isPending } = useMutation({
        mutationFn: forceDeleteSupplier,
        onSuccess: (res) => {
            toast.success(res.message || "Supplier force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to force delete supplier");
        },
    });

    return { forceDeleteSupplierMutate, isPending };
};

export default useForceDeleteSupplier;
